import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take, filter } from 'rxjs/operators';
import { selectAuthState } from '../ngrx/auth/auth.selectors';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const requiredRole = route.data['role'];
    
    return this.store.select(selectAuthState).pipe(
      // Wait until auth is initialized
      filter(state => state.isInitialized),
      // Only take one emission
      take(1),
      map(state => {

        if (!state.user?.roles?.includes(requiredRole)) {
          this.router.navigate(['/401']);
          return false;
        }

        return true;
      })
    );
  }
}

